var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRelevant)?_c('i',{staticClass:"tm-overlay-expired"},[(_vm.showSelfExpiredBanner)?_c('i',{staticClass:"-banner"},[_vm._v(" Expired ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }